<template>
  <div class="role">
    <el-container>
      <!-- 侧边栏，角色列表 -->
      <div class="role-list-container">
        <div class="role-title">
          <div class="title-name">角色列表</div>
          <div>
            <el-button
              icon="el-icon-plus"
              size="mini"
              plain
              type="primary"
              @click.stop="handleAdd()"
              >新增角色</el-button
            >
          </div>
        </div>
        <div class="role-list">
          <el-scrollbar>
            <el-aside
              width="210px"
              style="background-color: rgb(238, 241, 246)"
            >
              <el-menu
                v-if="roleList.length != 0"
                :default-active="currentRole.roleId + ''"
                @select="selectRole"
              >
                <el-menu-item
                  v-for="item in roleList"
                  :key="item.roleId"
                  :index="item.roleId + ''"
                >
                  <div class="list-item" slot="title">
                    <template>
                      <!-- 名称： 新增节点增加class -->
                      <div class="comp-node--name">
                        {{ item.roleName }}
                      </div>
                      <!-- 按钮 -->
                      <div class="comp-btns-wrap">
                        <!-- 编辑 -->
                        <i
                          class="el-icon-edit"
                          @click.stop="handleEditRole(item)"
                        ></i>
                        <!-- 删除 -->
                        <i
                          class="el-icon-delete"
                          v-if="item.status != 0"
                          @click.stop="handleDel(item.roleId)"
                        ></i>
                      </div>
                    </template>
                  </div>
                </el-menu-item>
              </el-menu>
            </el-aside>
          </el-scrollbar>
        </div>
      </div>
      <!-- 角色权限、角色成员 -->
      <el-container>
        <!-- 角色解释 -->
        <el-main class="role-content-main">
          <div class="role-notes">
            <div class="role-name">{{ currentRole.roleName }}</div>
            <div class="role-detail">{{ currentRole.remark }}</div>
          </div>
          <!-- tab -->
          <el-tabs v-model="activeName">
            <el-tab-pane label="角色成员" name="first"
              ><RoleMembers
                @reGet="reGet"
                :roleId="currentRole.roleId"
                :roleEmp="RoleEmpMenuId.roleEmp"
            /></el-tab-pane>
            <el-tab-pane label="功能权限" name="second"
              ><Authority
                @reGet="reGet"
                :roleId="currentRole.roleId"
                :roleEmp="RoleEmpMenuId.roleEmp"
                :empMenuId="RoleEmpMenuId.empMenuId"
            /></el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
    <AddRole ref="AddRole" @createSuccess="createSuccess" />
  </div>
</template>
<script>
import RoleMembers from "./roleComponents/RoleMembers.vue";
import Authority from "./roleComponents/Authority.vue";
import AddRole from "./roleComponents/addRole.vue";
import {
  getRole,
  createRoleEmp,
  deleteRole,
  getRoleEmpMenuId,
  getPointDetail,
} from "@/api/role/role.js";
export default {
  components: {
    RoleMembers,
    Authority,
    AddRole,
  },
  data() {
    return {
      activeName: "first",
      selectButtonName: "roleName",
      currentRole: {}, // 当前角色
      roleList: [], // 角色列表
      RoleEmpMenuId: {}, // 存放角色成员和角色勾选权限
      // point: {},
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.type != "") {
        return "background-row-shuang";
      }
    },
    // 新增/编辑 角色成功回调
    createSuccess(val) {
      if (val == "成功") {
        this.getRoleList();
      }
    },
    // 选择角色
    selectRole(index) {
      this.roleList.forEach((item) => {
        if (item.roleId == index) {
          this.currentRole = JSON.parse(JSON.stringify(item));
        }
      });
    },
    // 删除角色
    handleDel(id) {
      this.$confirm("您确定删除该角色？提交后将无法撤回", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      })
        .then((res) => {
          let params = { roleId: id };
          this.deleteRole(params);
        })
        .catch((action) => {
          // this.$message("取消删除");
        });
    },
    // 编辑角色
    handleEditRole(item) {
      this.$refs.AddRole.open(item);
    },
    // 添加角色
    handleAdd() {
      this.$refs.AddRole.open();
    },
    // 获取角色列表
    getRoleList() {
      let that = this;
      getRole(localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.roleList = res.data.roleList;
            that.roleList.forEach((item) => {
              if (item.status == 0) {
                // 默认显示超级管理员
                that.currentRole = JSON.parse(JSON.stringify(item));
              }
            });
          }
        })
        .catch((action) => {
          this.$message.error("获取角色列表失败");
        });
    },
    reGet() {
      let params = { roleId: this.currentRole.roleId };
      this.getRoleEmpMenuId(params);
      // this.getPointDetail()
    },
    // 获取角色对应员工范围和menuId
    getRoleEmpMenuId(params) {
      getRoleEmpMenuId(params, localStorage.getItem("Authorization")).then(
        (res) => {
          if (res.error.code == 200) {
            this.RoleEmpMenuId = res.data;
          }
        }
      );
    },
    // 删除角色请求
    deleteRole(params) {
      deleteRole(params, localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.getRoleList();
        }
      });
    },
  },
  created() {
    this.getRoleList();
  },
  watch: {
    selectButtonName: {
      handler(newVal, oldVal) {
        console.log(newVal);
      },
    },
    currentRole: {
      handler(newVal, oldVal) {
        let params = { roleId: newVal.roleId };
        this.getRoleEmpMenuId(params);
        // this.getPointDetail()
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
// 显示按钮
.show-btns {
  opacity: 1;
}
.role {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .role-list-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    width: 210px;
    transform: translateX(-19px);
    border-right: 1px solid #ebeef5;
    .role-title {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 20px;
      .title-name {
        font-size: 13px;
        font-weight: bold;
      }
    }
    .role-list {
      flex: 1;
      overflow: hidden;
      .list-item {
        flex: 1;
        display: flex;
        height: 40px;
        padding: 8px 9px 8px 15px;
        justify-content: space-between;
      }
      .comp-node--name {
        display: flex;
        font-size: 14px;
        justify-content: center;
        align-items: center;
      }
      /deep/.el-menu-item {
        height: auto;
        line-height: unset;
        padding: 0 8px 0 0px !important;
      }
      /deep/.el-menu-item [class^="el-icon-"] {
        width: unset;
        font-size: 17px;
      }
      /deep/ .el-icon-edit {
        color: #909399;
      }
      /deep/ .el-icon-delete {
        color: #f56c6c;
        margin-left: 5px;
      }
      /deep/ .el-menu {
        border-right: none;
      }
      /deep/.el-menu-item.is-active .list-item {
        color: #409eff;
        outline: 0;
        background-color: rgb(244, 247, 252);
      }
      /deep/.el-menu-item.is-active {
        background-color: transparent;
      }
      /deep/.is-active .list-item {
        border-right: 2px solid;
      }
      .list-item:focus {
        outline: 0;
        background-color: rgb(244, 247, 252);
      }
      /deep/.el-menu-item:focus,
      .el-menu-item:hover {
        outline: 0;
        background-color: transparent;
      }
      /deep/ .el-scrollbar {
        height: 100%;
      }
      .comp-btns-wrap {
        opacity: 0;
        transition: opacity 0.1s;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        /deep/.el-button {
          transform: scale(0.8); // 缩小按钮
          z-index: 1;
          & + .el-button {
            margin-left: -1px;
          }
        }
      }
      // /deep/.el-menu-item.is-active {
      //   .comp-btns-wrap{
      //     @extend .show-btns;
      //   }
      // }
      // 悬浮显示按钮
      /deep/.el-menu-item {
        &:hover {
          .comp-btns-wrap {
            @extend .show-btns;
          }
          // i {
          //   color: white;
          // }
        }
      }
    }
  }
  /deep/.role-content-main {
    padding: 0;
    display: flex;
    flex-direction: column;
    .role-notes {
      display: flex;
      justify-content: flex-start;
      align-items: baseline;
      margin-bottom: 20px;
      .role-name {
        font-size: 17px;
        font-weight: bold;
        margin-right: 10px;
      }
      .role-detail {
        font-size: 14px;
        flex: 1;
      }
    }
    .el-tabs {
      flex: 1;
      display: flex;
      flex-direction: column;
      .el-tabs__content {
        flex: 1;
        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
}
</style>
